import router from './router'
import store from './store'

import { toPathWhiteList } from '@/defaultFields/index.js'

// const platform_title = store.getters['config/getCurrentCommunity']
const navList = store.getters['config/getNavList']

router.beforeEach(async (to, from, next) => {
  let currentCommunity = localStorage.getItem('currentCommunity') || ''
  const { village = '' } = to.query
  if (village) {
    currentCommunity = village
    localStorage.setItem('currentCommunity', currentCommunity)
    const admini = currentCommunity.includes('社区') ? '社区' : '村'
    localStorage.setItem('admini', admini)
  }
  /*
    when you're useing management ('/viewPlatform'),
    path has query (userid), for business pages can see data under review.
    when the device you're useing is a computer and you can see the data under review (this project),
    you can delete your browser's localStorage(screenUserid) and refresh your page.
  */
  let screenUserid = localStorage.getItem('screenUserid') || 0
  if (to.query.screenUserid) {
    screenUserid = to.query.screenUserid
    localStorage.setItem('screenUserid', screenUserid)
  }

  /* for templateName */
  let businessId = localStorage.getItem('businessId') || 0
  if (to.query.businessId) {
    businessId = to.query.businessId
    localStorage.setItem('businessId', businessId)
  }

  if (navList && navList.length > 0) next()

  document.title = `${to.meta.title ? `${to.meta.title} -` : ''} ${currentCommunity}`
  to.path && to.meta.title ? next() : next('/development')
  // console.log('setting', to.path)
  if (toPathWhiteList.includes(to.path)) store.commit('config/SET_toPath', to.path)
  // const hasNavList = store.getters['config/getNavList']
  // if (hasNavList.length > 0) {
  //   next()
  // } else {
  //   await store.dispatch('config/getNavListReq')
  //   next()
  // }
})
